"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9274],{

/***/ 36604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ParksApi; }
/* harmony export */ });
/* harmony import */ var _parkschannel_next_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74552);

class ParksApi {
    getParksByType(params, parksParams) {
        var ref, ref1;
        return this.client.get("".concat(this.baseUrl), {
            params: {
                page: params.page,
                limit: params.limit,
                search: params.search,
                random: parksParams.random || null,
                "filter.parkType": parksParams.type ? "$eq:".concat(parksParams.type) : null,
                ...(parksParams === null || parksParams === void 0 ? void 0 : (ref = parksParams.states) === null || ref === void 0 ? void 0 : ref.length) ? {
                    "filter.states": "$in:".concat(parksParams.states.join(","))
                } : {},
                ...(parksParams === null || parksParams === void 0 ? void 0 : (ref1 = parksParams.tags) === null || ref1 === void 0 ? void 0 : ref1.length) ? {
                    "filter.tags.name": "$in:".concat(parksParams.tags.join(","))
                } : {},
                ...(parksParams === null || parksParams === void 0 ? void 0 : parksParams.sortBy) ? {
                    sortBy: parksParams.sortBy
                } : {}
            }
        }, false);
    }
    getParks(paginationParams) {
        return this.client.get("".concat(this.baseUrl), {
            params: {
                ...paginationParams
            }
        }, false);
    }
    getPark(idOrSlug) {
        return this.client.get("".concat(this.baseUrl, "/").concat(idOrSlug), {}, false);
    }
    async getParkVideos(idOrSlug, params) {
        return this.client.get("".concat(this.baseUrl, "/").concat(idOrSlug, "/popular_videos"), {
            params
        }, false);
    }
    async getSponsorsVideos(idOrSlug, sponsorId) {
        return this.client.get("".concat(this.baseUrl, "/").concat(idOrSlug, "/sponsor_videos?sponsor=").concat(sponsorId), {}, false);
    }
    async getParkAuthors(idOrSlug, params) {
        return this.client.get("".concat(this.baseUrl, "/").concat(idOrSlug, "/popular_authors"), {
            params
        }, false);
    }
    constructor(client = new _parkschannel_next_utils__WEBPACK_IMPORTED_MODULE_0__/* .HttpClient */ .e()){
        this.client = client;
        this.baseUrl = "/api/parks";
    }
}


/***/ }),

/***/ 7336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ useParks; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.2.1_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(15265);
// EXTERNAL MODULE: ./modules/Api/Parks/index.ts
var Parks = __webpack_require__(36604);
// EXTERNAL MODULE: ../next-utils/src/lib/env.ts
var env = __webpack_require__(57399);
;// CONCATENATED MODULE: ./modules/Api/Wordpress/WordpressApi.ts

class WordpressApi {
    getParkArticles(parkSlug) {
        return fetch("".concat(this.baseUrl, "/wp-json/wp/v2/park_content/?park_name=").concat(parkSlug, "&_embed"), {
            method: "GET"
        }).then((res)=>res.json());
    }
    constructor(baseUrl = (0,env/* getEnvVariables */.S)()["WORDPRESS_URL"]){
        this.baseUrl = baseUrl;
    }
}

// EXTERNAL MODULE: ./modules/Config/ConfigContext.tsx
var ConfigContext = __webpack_require__(65729);
;// CONCATENATED MODULE: ./modules/Parks/hooks.ts




const useParks = ()=>{
    const { wordpressUrl  } = (0,ConfigContext/* useConfig */.ZR)();
    const parkApi = new Parks/* ParksApi */.y();
    const wordpressApi = new WordpressApi(wordpressUrl);
    const useParksQuery = (pagination, parksParams, config)=>(0,index_production.useQuery)([
            "parks",
            pagination,
            parksParams
        ], ()=>parkApi.getParksByType(pagination, parksParams), {
            ...config
        });
    const useParkQuery = (id)=>(0,index_production.useQuery)([
            "parks",
            id
        ], async ()=>await parkApi.getPark(id));
    const useParkArticles = (slugOrId)=>(0,index_production.useQuery)([
            "wordpress",
            "park-articles",
            slugOrId
        ], async ()=>wordpressApi.getParkArticles(slugOrId));
    const useSponsorVideos = (id, sponsorId, config)=>{
        return (0,index_production.useQuery)([
            "videos",
            "park",
            "sponsor",
            id,
            sponsorId
        ], async ()=>await parkApi.getSponsorsVideos(id, sponsorId), {
            keepPreviousData: true,
            ...config
        });
    };
    const useParkVideos = (id, pagination, config)=>{
        return (0,index_production.useQuery)([
            "videos",
            "park",
            id,
            pagination
        ], async ()=>await parkApi.getParkVideos(id, pagination), {
            keepPreviousData: true,
            ...config
        });
    };
    const useParkAuthors = (id, pagination, config)=>{
        return (0,index_production.useQuery)([
            "authors",
            "park",
            id,
            pagination
        ], async ()=>await parkApi.getParkAuthors(id, pagination), {
            keepPreviousData: true,
            ...config
        });
    };
    return {
        useParksQuery,
        useParkQuery,
        useParkVideos,
        useParkAuthors,
        useParkArticles,
        useSponsorVideos
    };
};


/***/ }),

/***/ 19274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ UserStickerListWithInfinityScroll; }
});

// UNUSED EXPORTS: UserStickerList

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../ui/src/components/ItemsList/ItemsList.tsx
var ItemsList = __webpack_require__(14927);
// EXTERNAL MODULE: ../ui/src/components/Typography/Typography.tsx
var Typography = __webpack_require__(59785);
// EXTERNAL MODULE: ../ui/src/components/Loading/Loading.tsx
var Loading = __webpack_require__(69193);
// EXTERNAL MODULE: ../ui/src/components/SimpleImage/index.tsx
var SimpleImage = __webpack_require__(86978);
// EXTERNAL MODULE: ../ui/src/icons/LocationMarkerIcon/LocationMarkerIcon.tsx
var LocationMarkerIcon = __webpack_require__(49811);
// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(83849);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash.isequal@4.5.0/node_modules/lodash.isequal/index.js
var lodash_isequal = __webpack_require__(17361);
var lodash_isequal_default = /*#__PURE__*/__webpack_require__.n(lodash_isequal);
;// CONCATENATED MODULE: ../ui/src/components/Sticker/StickerCard.tsx







const StickerCard = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { data , renderImage , className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: classnames_default()("w-full h-[230px] p-6 drop-shadow-sm hover:shadow-xl  rounded-2xl bg-white flex flex-col items-center transition-all duration-200", {
            "grayscale ": !data.isUnlocked
        }, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative w-full h-[120px] w-full mb-3",
                children: [
                    renderImage ? renderImage(data.stickerKey, data.name) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleImage/* SimpleImage */.E, {
                        src: data.stickerKey,
                        alt: data.name,
                        fill: true,
                        className: "object-contain"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("absolute top-0 left-0 w-full h-full bg-white/75", {
                            hidden: data.isUnlocked
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                component: "h3",
                variant: "h6",
                className: classnames_default()("line-clamp-2 text-center !text-[16px] mb-1", {
                    "text-neutral-500": !data.isUnlocked,
                    "text-neutral-900": data.isUnlocked
                }),
                children: data.name
            }),
            data.states.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-center gap-1 w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationMarkerIcon/* LocationMarkerIcon */.I, {
                        className: "w-5 h-5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        variant: "captionBase",
                        className: "text-neutral-500 inline",
                        children: data.states[0]
                    })
                ]
            }) : null
        ]
    });
}, arePropsEqual);
function arePropsEqual(prevProps, nextProps) {
    return lodash_isequal_default()(prevProps, nextProps);
}

// EXTERNAL MODULE: ./modules/ImgixImage/index.tsx
var ImgixImage = __webpack_require__(86645);
;// CONCATENATED MODULE: ./modules/Sticker/StickerCard/StickerCard.tsx




const ONE_DAY = 7 * 24 * 60 * 60 * 1000;
const StickerCard_StickerCard = (param)=>{
    let { renderImage , onClick , ...rest } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative cursor-pointer",
        tabIndex: 0,
        onClick: ()=>{
            return onClick === null || onClick === void 0 ? void 0 : onClick(rest.data);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StickerCard, {
                ...rest,
                renderImage: renderImage || ((imgKey, name)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ImgixImage/* ImgixImage */.T, {
                        src: imgKey,
                        alt: name,
                        fill: true,
                        className: "object-contain"
                    }))
            }),
            rest.data.stickerDate ? findTimeElapsed(new Date(rest.data.stickerDate)) < ONE_DAY ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewLabel, {}) : null : null
        ]
    });
};
function NewLabel() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-2 py-1 rounded-2xl bg-yellow1 absolute top-4 right-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
            variant: "bodySmall",
            className: "text-neutral-700",
            children: "New"
        })
    });
}
function findTimeElapsed(start) {
    const now = Date.now();
    return now - start.getTime();
}

;// CONCATENATED MODULE: ./modules/Sticker/Sticker.ts
class Sticker {
    static fromStickerDTO(dto) {
        return new Sticker(dto.parkId, dto.name, dto.stickerUrl, dto.isUnlocked, dto.stickerKey, dto.stickerDate, dto.stickerProviderName, dto.stickerProviderLink, dto.states);
    }
    toJSON() {
        return {
            parkId: this.parkId,
            name: this.name,
            stickerUrl: this.stickerUrl,
            isUnlocked: this.isUnlocked,
            stickerKey: this.stickerKey,
            id: this.parkId,
            stickerDate: this.stickerDate,
            stickerProviderName: this.stickerProviderName,
            stickerProviderLink: this.stickerProviderLink,
            states: this.states
        };
    }
    get id() {
        return this.parkId;
    }
    constructor(parkId, name, stickerUrl, isUnlocked, stickerKey, stickerDate, stickerProviderName, stickerProviderLink, states){
        this.parkId = parkId;
        this.name = name;
        this.stickerUrl = stickerUrl;
        this.isUnlocked = isUnlocked;
        this.stickerKey = stickerKey;
        this.stickerDate = stickerDate;
        this.stickerProviderName = stickerProviderName;
        this.stickerProviderLink = stickerProviderLink;
        this.states = states;
    }
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/react-intersection-observer@9.4.1_react@18.2.0/node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(7154);
// EXTERNAL MODULE: ./modules/Parks/hooks.ts + 1 modules
var hooks = __webpack_require__(7336);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.3-canary.1_rlaikcoslzwwtqyk7brpdzej5y/node_modules/next/link.js
var next_link = __webpack_require__(66998);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./modules/Parks/path.ts
var path = __webpack_require__(10686);
// EXTERNAL MODULE: ../ui/src/components/Modal/Modal.tsx + 1 modules
var Modal = __webpack_require__(88044);
// EXTERNAL MODULE: ../ui/src/components/IconButton/IconButton.tsx
var IconButton = __webpack_require__(38937);
// EXTERNAL MODULE: ../ui/src/icons/ArrowRight/ArrowRight.tsx
var ArrowRight = __webpack_require__(71740);
// EXTERNAL MODULE: ../ui/src/components/Skeleton/Skeleton.tsx
var Skeleton = __webpack_require__(2783);
;// CONCATENATED MODULE: ./modules/UserProfile/UserStickerList/StickerModal.tsx







const StickerModal = (param)=>{
    let { isOpen , onClose , parkId  } = param;
    const { useParkQuery  } = (0,hooks/* useParks */.V)();
    const { data  } = useParkQuery(parkId);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
        isOpen: isOpen,
        setIsOpen: onClose,
        contentClassName: "max-w-6xl",
        children: data ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StickerModalContent, {
            data: data
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StickerModalSkeleton, {})
    });
};
function StickerModalContent(param) {
    let { data  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: "lg:flex lg:gap-10 lg:items-center lg:relative lg:items-stretch",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-10 mb-10 mt-10 border-b-2 border-b-neutral-100 lg:min-w-[398px] lg:w-[398px] lg:border-b-0 lg:border-r-2 lg:mt-0 lg:mb-0 lg:pb-0 lg:flex lg:items-center lg:self-stretch ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative w-full h-[250px] md:h-[318px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgixImage/* ImgixImage */.T, {
                        src: data.stickerKey || "",
                        alt: data.name,
                        fill: true,
                        className: "object-contain"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:flex lg:flex-col lg:justify-center ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:grow lg:py-10 ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                variant: "h3",
                                className: "text-neutral-900 mb-1",
                                children: data.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-start gap-1 w-full mb-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationMarkerIcon/* LocationMarkerIcon */.I, {
                                        className: "min-w-[20px] w-5 h-5 mt-[2px]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "flex flex-wrap gap-x-2",
                                        children: data.states.map((state, id)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    variant: "captionBase",
                                                    className: "text-neutral-500 inline",
                                                    children: state
                                                })
                                            }, id))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                variant: "bodyXL",
                                className: "text-neutral-700 mb-10",
                                children: data.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: (0,path/* useResolveParkPagePath */.A)(data.slug),
                        className: "lg:absolute lg:bottom-0 lg:right-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* ArrowRight */.o, {
                                className: "w-5 h-5"
                            }),
                            variant: "base",
                            tabIndex: -1,
                            className: "w-full !drop-shadow text-[14px] flex justify-center",
                            children: "Go to park page"
                        })
                    })
                ]
            })
        ]
    });
}
function StickerModalSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "py-6 flex items-center flex-col lg:flex-row lg:gap-10 lg:px-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                variant: "rounded",
                animation: "animate-shimmer",
                width: "250px",
                height: "250px",
                className: "lg:min-w-[250px]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col w-full mt-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "250px",
                        height: "15px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "100px",
                        height: "15px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "100%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "100%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "95%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "50%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "100%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "100%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "100%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "100%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "95%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "50%",
                        height: "15px"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./modules/UserProfile/UserStickerList/UserStickerList.tsx







const UserStickerList = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { data , onItemClick  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsList/* ItemsList */.o, {
        className: "w-full py-6 grid gap-4 sm:grid-cols-2 md:gap-6 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5",
        items: data,
        noItemsMessage: "Parks stickers not found",
        renderItem: (sticker)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(StickerCard_StickerCard, {
                data: sticker,
                onClick: (data)=>{
                    return onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(data);
                }
            });
        }
    });
}, areEqual);
function areEqual(prevProps, nextProps) {
    return lodash_isequal_default()(prevProps, nextProps);
}
const UserStickerListWithInfinityScroll = (param)=>{
    let { data , hasNextPage , fetchNextPage , isFetchingNextPage  } = param;
    const { ref , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)();
    const [selectedSticker, setSelectedSticker] = (0,react.useState)(null);
    const mergedPages = (0,react.useMemo)(()=>{
        return data.pages.reduce((acc, curr)=>[
                ...acc,
                ...curr.data
            ], []).map((sticker)=>Sticker.fromStickerDTO(sticker));
    }, [
        data
    ]);
    const handleSelectSticker = (0,react.useCallback)((sticker)=>{
        setSelectedSticker(sticker);
    }, []);
    (0,react.useEffect)(()=>{
        if (inView && hasNextPage) {
            fetchNextPage();
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-full",
        id: "user-parks-section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                variant: "bodyXL",
                className: "text-neutral-600 font-normal mt-10 mb-[26px] !text-[16px]",
                children: [
                    "All stickers provided by Anderson Design Group. To see more, visit",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.andersondesigngroupstore.com",
                        className: "underline",
                        target: "_blank",
                        children: "andersondesigngroupstore.com"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserStickerList, {
                data: mergedPages,
                onItemClick: handleSelectSticker
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref,
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    disabled: !hasNextPage,
                    onClick: ()=>fetchNextPage(),
                    children: isFetchingNextPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {}) : !hasNextPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        variant: "captionBase",
                        className: "text-neutral-500",
                        children: "No more to fetch..."
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        variant: "captionBase",
                        className: "text-neutral-900",
                        children: "Load more"
                    })
                })
            }),
            selectedSticker && /*#__PURE__*/ (0,jsx_runtime.jsx)(StickerModal, {
                isOpen: !!selectedSticker,
                onClose: ()=>setSelectedSticker(null),
                parkId: selectedSticker.parkId
            })
        ]
    });
};


/***/ }),

/***/ 7154:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const observerMap = new Map();
const RootIds = new WeakMap();
let rootId = 0;
let unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(key => options[key] !== undefined).map(key => {
    return `${key}_${key === 'root' ? getRootId(options.root) : options[key]}`;
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  let id = optionsToId(options);
  let instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    const elements = new Map();
    let thresholds;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        const inView = entry.isIntersecting && thresholds.some(threshold => entry.intersectionRatio >= threshold); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(callback => {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  const {
    id,
    observer,
    elements
  } = createObserver(options); // Register the callback listener for this element

  let callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements.delete(element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

const _excluded = (/* unused pure expression or super */ null && (["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"]));

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


class InView extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    this.node = null;
    this._unobserveCb = null;

    this.handleNode = node => {
      if (this.node) {
        // Clear the old observer, before we start observing a new element
        this.unobserve();

        if (!node && !this.props.triggerOnce && !this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          this.setState({
            inView: !!this.props.initialInView,
            entry: undefined
          });
        }
      }

      this.node = node ? node : null;
      this.observeNode();
    };

    this.handleChange = (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        this.unobserve();
      }

      if (!isPlainChildren(this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        this.setState({
          inView,
          entry
        });
      }

      if (this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        this.props.onChange(inView, entry);
      }
    };

    this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
  }

  componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }

  componentWillUnmount() {
    this.unobserve();
    this.node = null;
  }

  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold,
      root,
      rootMargin,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
  }

  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  }

  render() {
    if (!isPlainChildren(this.props)) {
      const {
        inView,
        entry
      } = this.state;
      return this.props.children({
        inView,
        entry,
        ref: this.handleNode
      });
    }

    const _this$props = this.props,
          {
      children,
      as
    } = _this$props,
          props = _objectWithoutPropertiesLoose(_this$props, _excluded);

    return React.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  }

}

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _state$entry;

  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: undefined
  }); // Store the onChange callback in a `ref`, so we can access the latest instance
  // inside the `useEffect`, but without triggering a rerender.

  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    // Ensure we have node ref, and that we shouldn't skip observing
    if (skip || !ref) return;
    let unobserve;
    unobserve = observe(ref, (inView, entry) => {
      setState({
        inView,
        entry
      });
      if (callback.current) callback.current(inView, entry);

      if (entry.isIntersecting && triggerOnce && unobserve) {
        // If it should only trigger once, unobserve the element after it's inView
        unobserve();
        unobserve = undefined;
      }
    }, {
      root,
      rootMargin,
      threshold,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
    return () => {
      if (unobserve) {
        unobserve();
      }
    };
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string, so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, ref, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  const entryTarget = (_state$entry = state.entry) == null ? void 0 : _state$entry.target;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!ref && entryTarget && !triggerOnce && !skip) {
      // If we don't have a node ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView,
        entry: undefined
      });
    }
  }, [ref, entryTarget, triggerOnce, skip, initialInView]);
  const result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.modern.mjs.map


/***/ })

}]);